export const useAPIFetch = (request, opts) => {
	return useFetch(request, { baseURL: "/", ...opts })
}